export default "__VITE_ASSET__7tXmMVL4__"